module.exports = __webpack_public_path__ + "img/case-logo-08.6e054b69.png";